import { normalizeProductId } from '../../product'

const PRODUCT_ID_VALIDATION_MAX_LENGTH = 12
const productIdValidationValidSaeIdRegex = /^(?:[a-z]{0,2})(?:\d{5,})$/iu

const productIdValidationValidMiraklIdRegex = /upm[a-z0-9]{6}/iu
const productValidationExpExceptionsIdRegex = [/^d\d$/iu]

const isMatchingAnyException = (id: string): boolean =>
  productValidationExpExceptionsIdRegex.some((regex) => regex.test(id))

/**
 * returns true if query has PZNs
 */
const validateUpidsAndPzns = (id: string): boolean => {
  if (!id || id.length > PRODUCT_ID_VALIDATION_MAX_LENGTH) {
    return false
  }

  let matches = productIdValidationValidSaeIdRegex.exec(id)

  matches ??= productIdValidationValidMiraklIdRegex.exec(id)

  return Boolean(matches) && !isMatchingAnyException(id)
}

/**
 * Optimizes a product search query by detecting if it contains only valid PZNs or UPIDs.
 * Pads IDs if needed and returns the optimized query string.
 *
 * @param searchQuery - The search query string, which may be null or undefined.
 * @returns An object with a boolean indicating if the query contains only valid PZNs/UPIDs,
 *          and the optimized search query string.
 */
export const productSearchOptimizeSearchQueryIfItHasPzns = (
  searchQuery?: string | null,
): { isPznQuery: boolean; searchQuery: string } => {
  if (!searchQuery) {
    return {
      isPznQuery: false,
      searchQuery: '',
    }
  }

  try {
    const possiblePzns = decodeURIComponent(searchQuery)
      .split(/[\s,+]+/gu)
      .filter((value, index, pzns) => pzns.indexOf(value) === index)
      .filter(Boolean)
    const allValid = possiblePzns.every((possiblePzn) => {
      return validateUpidsAndPzns(possiblePzn)
    })
    if (!allValid) {
      return {
        isPznQuery: false,
        searchQuery,
      }
    }

    return {
      isPznQuery: true,
      searchQuery: possiblePzns.map((pzn) => normalizeProductId(pzn)).join(' '),
    }
  } catch {
    return {
      isPznQuery: false,
      searchQuery,
    }
  }
}
